import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { mealItemEditModalStore } from '../../store/mealItemEditModalStore';
import { BUTTON_TITLE } from '~/constants/main';
import integrationsStore from '~/mobx/integrationStore';
import { localeStore } from '~/mobx/localesStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import ModalFooter from '~/view/components/Controls/Modal/ModalFooter/ModalFooter';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';

export const MealItemEditModalFooter: FC = memo(
  observer((): ReactElement => {
    const { comboMealChangeItemInItemChoice } = integrationsStore.posRestrictions || {};

    return (
      <ModalFooter className="flex-column align-items-center">
        <Button
          title={localeStore.t(BUTTON_TITLE.SAVE)}
          onClick={mealItemEditModalStore.onSubmit}
          size="large"
          className="meal-edit-modal__btn-save"
        />

        {mealItemEditModalStore.isEditAction ? (
          <IntegrationManager
            setting={comboMealChangeItemInItemChoice}
            wrapperClassName="mt-6"
            tooltipOptions={{ position: TOOLTIP_POSITION.PORTAL }}
            withTooltip
          >
            <button onClick={mealItemEditModalStore.onDelete} disabled={!mealItemEditModalStore.item} className="meal-edit-modal__btn-delete">
              {localeStore.t(BUTTON_TITLE.DELETE)}
            </button>
          </IntegrationManager>
        ) : null}
      </ModalFooter>
    );
  })
);
